import Joi from 'joi';

export const MoveLicenseToOrgUnitValidator = {
  schema: Joi.object()
    .keys({
      licensedOrgUnitId: Joi.number().required()
    })
    .unknown(true)
};
